import {APIResponse} from "./types";
import exp from "node:constants";

export enum PropertyStatus {
    Sold = "sold",
    Open = "open",
    ComingSoon = "coming_soon",
}

export interface Property {
    developer_ids: number[];
    payment_plan_ids: number[];
    amenity_ids: number[];
    name: string;
    type: string;
    description: string;
    bed: string;
    bath: string;
    min_bed: number | null;
    max_bed: number | null;
    min_bath: number | null;
    max_bath: number | null;
    area: number | null;
    street_address: string;
    county: string;
    state: string;
    country: string;
    zipcode: string;
    price: number | null;
    status: PropertyStatus;
    latitude: number | null;
    longitude: number | null;
}

export interface PropertyInfo extends Property {
    id: number | null;
    property_images: string[];
    amenities: string[];
}

export interface PropertyInfoTop {
    id : number | null;
    name: string;
    price: number | null;
    developer_names: string[];
    property_image: string;
}

export interface PropertyGetResponse extends APIResponse {
    data: PropertyInfo;
}

export interface PropertyGetSearchResponse extends APIResponse {
    data: PropertyInfo[];
}

export interface PropertyGetTopResponse extends APIResponse {
    data: PropertyInfoTop[];
}

export interface PropertyCreateResponse extends APIResponse {
    id: number
}

export interface ImageUploadRequest {
    id: number;
}

export interface FileJob {
    file_name: string;
    job_id: string;
    err: string;
}

export interface ImageUploadResponse extends APIResponse {
    data: FileJob[];
}